const strings = {
  'heatstreak/correct/text': {
    en: (points) => {
      return `<span>Daily Prize:</span> ${points}pts`;
    },
    fr: (points) => {
      return `<span>Prix quotidien :</span> ${points} points`;
    },
  },
  'heatstreak/offers/text': {
    en: '<span>Daily Prize:</span> Offer',
    fr: '<span>Prix quotidien :</span> Offre',
  },
  'heatstreak/incorrect/text': {
    en: 'None of your picks were correct.',
    fr: 'Aucun de vos choix n’était bon.',
  },
  'heatstreak/noPicks/text': {
    en: `You haven't selected picks for the past 7 days.`,
    fr: `Vous n’avez pas sélectionné de joueurs au cours des 7 derniers jours.`,
  },
  'heatstreak/banner/gold/text': {
    en: (percentage) => {
      return `You’re playing better than <span>${percentage}</span> of the other players right now. Keep it up!`;
    },
    fr: (percentage) => {
      return `Vous jouez mieux que <span>${percentage}</span> des autres participants en ce moment. Continuez comme ça!`;
    },
  },
  'heatstreak/banner/silver/text': {
    en: (percentage) => {
      return `You’re playing better than <span>${percentage}</span> of the other players right now. Keep playing!`;
    },
    fr: (percentage) => {
      return `Vous jouez mieux que <span>${percentage}</span> des autres participants en ce moment. Continuez à jouer!`;
    },
  },
  'heatstreak/banner/bronze/text': {
    en: (percentage) => {
      return `You’re playing better than <span>${percentage}</span> of the other players right now. Step your game up!`;
    },
    fr: (percentage) => {
      return `Vous jouez mieux que <span>${percentage}</span> des autres participants en ce moment. Sortez le grand jeu!`;
    },
  },
  'heatstreak/panel/winStreak/header': {
    en: 'My streak',
    fr: 'Ma série de victoires',
  },
  'heatstreak/panel/winStreak/title': {
    en: (streak) => {
      return `${streak} Day Win Streak`;
    },
    fr: (streak) => {
      return `Série de victoires consécutives de ${streak} jours`;
    },
  },
  'heatstreak/panel/winStreak/badge': {
    en: 'DAY',
    fr: 'Jour',
  },
  'heatstreak/panel/winStreak/text': {
    en: (streak) => {
      if (streak === 1) {
        return 'Keep your streak alive for 1 more day to win a week of FREE donuts!';
      }
      return `Keep your streak alive for ${streak} more days to win a week of FREE donuts!`;
    },
    fr: (streak) => {
      if (streak === 1) {
        return 'Maintenez votre série de victoires consécutives pendant encore 1 jour pour gagner une semaine de beignes GRATUITS!';
      }
      return `Maintenez votre série de victoires consécutives pendant encore ${streak} jours pour gagner une semaine de beignes GRATUITS!`;
    },
  },
  'heatstreak/panel/winStreak/complete/title': {
    en: 'You won a FREE* donut for a week!',
    fr: 'Vous avez gagné un beigne GRATUIT* pendant une semaine!',
  },
  'heatstreak/panel/winStreak/complete/text': {
    en: 'You were on fire this week! Congrats on winning big. Please see your offer tray on the home page for your prize.',
    fr: 'Quelle semaine! Félicitations. Consultez le plateau d’offres sur la page d’accueil pour votre prix.',
  },
  'heatstreak/statistic/challengeStats/title': {
    en: 'Monthly Challenge',
    fr: `Statistiques du défi mensuel`,
  },
  'heatstreak/statistic/seasonStats/title': {
    en: 'NHL® 2026/2027 Regular Season Challenge Stats',
    fr: 'Statistiques du Défi de la saison régulière 2026-2027 de la LNH<sup>MD</sup>',
  },
  'heatstreak/statistic/postseasonStats/title': {
    en: 'Stanley Cup®<br /> Playoffs Challenge Stats',
    fr: 'Statistiques du Défi des séries éliminatoires de la Coupe Stanley<sup style="font-size: 10px; top: -0.5em">MC</sup>',
  },
  'heatstreak/statistic/pickAccuracy/title': {
    en: 'pick<br />accuracy',
    fr: 'Taux de réussite',
  },
  'heatstreak/statistic/correctPicks/title': {
    en: 'number of<br />correct picks',
    fr: 'Nombre de<br />prédictions<br />réussies',
  },
  'heatstreak/statistic/daysPlayed/title': {
    en: 'number of<br />days played',
    fr: 'Nombre de<br />jours de<br />participation',
  },
  'heatstreak/statistic/mychallenges/title': {
    en: 'My challenges',
    fr: 'Mes défis',
  },
  'heatstreak/statistic/status/progress': {
    en: 'In Progress',
    fr: 'En Cours',
  },
  'heatstreak/statistic/status/completed': {
    en: 'Completed',
    fr: 'Terminé',
  },
  'heatstreak/gameinfo/blurb': {
    en: 'Guessed correctly for 7 consecutive days? You’ll win a free donut for a week!*',
    fr: 'Vous avez fait les bons choix pendant 7 jours consécutifs? Vous gagnez un beigne gratuit pendant une semaine*!',
  },
  'heatstreak/gameinfo/disclaimer': {
    en: '*Terms and conditions apply.',
    fr: '*Des modalités s’appliquent.',
  },
  'heatstreak/gameinfo/disclaimerTerms': {
    en: 'View terms and conditions (<a target="_parent" href="https://www.timhortons.ca/defi-de-hockey-de-la-lnh-de-tim-hortons">FR</a> | <a target="_parent" href="https://www.timhortons.ca/tims-nhl-hockey-challenge">EN</a>)',
    fr: '<a target="_parent" href="https://www.timhortons.ca/defi-de-hockey-de-la-lnh-de-tim-hortons">Voir les modalités</a>',
  },
  'heatstreak/gameinfo/image': {
    en: '2026_streak_card_en.png',
    fr: '2026_streak_card_fr.png',
  },
  'heatstreak/minibanner/title': {
    en: 'Stanley Cup® Playoffs Challenge',
    fr: 'Défi des séries éliminatoires de la Coupe Stanley<sup>MC</sup>',
  },
  'heatstreak/minibanner/playoffs/date': {
    en: 'April 18',
    fr: '18 avril',
  },
  'heatstreak/minibanner/monthly/date': {
    en: 'Nov - Dec',
    fr: 'Nov - Déc',
  },
  'heatstreak/minibanner/text': {
    en: 'Put your playoff knowledge to the test for a chance to win <b>a Grand Prize of $5,000!</b>',
    fr: 'Testez vos connaissances des séries éliminatoires et courez la chance de gagner le grand prix de 5 000 $!',
  },
  'heatstreak/minibanner/link': {
    en: 'View prize info',
    fr: 'Voir les informations sur les prix',
  },
  'heatstreak/minibanner/route': {
    en: '/game-info',
    fr: '/game-info',
  },
};

export default strings;
